export enum ClassificationType {
  DEFAULT = 1,
  AUTO = 2,
  MANUALLY = 3
}
